import {Component, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, Data, Router} from "@angular/router";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {TreoMediaWatcherService} from "@treo/services/media-watcher";
import {TreoNavigationService} from "@treo/components/navigation";
import {Usuarios} from "app/models/Usuario/usuarios.model";

@Component({
	selector: "classy-layout",
	templateUrl: "./classy.component.html",
	styleUrls: ["./classy.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
	data: any;
	isScreenSmall: boolean;

	// Private
	private _unsubscribeAll: Subject<any>;

	/**
	 * Constructor
	 *
	 * @param {ActivatedRoute} _activatedRoute
	 * @param {TreoMediaWatcherService} _treoMediaWatcherService
	 * @param {TreoNavigationService} _treoNavigationService
	 * @param {Router} _router
	 */
	constructor(
		private _activatedRoute: ActivatedRoute,
		private _treoMediaWatcherService: TreoMediaWatcherService,
		private _treoNavigationService: TreoNavigationService,
		private _router: Router,
	) {
		// Set the private defaults
		this._unsubscribeAll = new Subject();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Subscribe to the resolved route data
		this._activatedRoute.data.subscribe((data: Data) => {
			this.data = data.initialData;
		});

		// Subscribe to media changes
		this._treoMediaWatcherService.onMediaChange$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe(({matchingAliases}) => {
				// Check if the breakpoint is 'lt-md'
				this.isScreenSmall = matchingAliases.includes("lt-md");
			});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Toggle navigation
	 *
	 * @param key
	 */
	toggleNavigation(key): void {
		// Get the navigation
		const navigation = this._treoNavigationService.getComponent(key);

		if (navigation) {
			// Toggle the opened status
			navigation.toggle();
		}
	}

	baixarApp(): void {
		const fileUrl = "https://pub-d73c0deaa5d24733962b77adc57cad9a.r2.dev/app.apk"; // ou 'assets/instalador.exe' se usar a pasta assets
		const fileName = "app.apk"; // Nome do arquivo ao ser baixado pelo usuário

		const link = document.createElement("a");
		link.href = fileUrl;
		link.setAttribute("download", fileName);

		// Adiciona ao DOM, clica e remove para não deixar resíduos no documento
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}
